import { ca } from '@cian/analytics';

export const trackMortgageBannerClick = () => {
  ca('eventSite', {
    ec: 'CardCountryBuilder',
    ea: 'Click',
    el: 'Mortgage_banner_CB',
  });
};
